import { createSelector } from 'reselect';

export const gethistories = (state, { historyName }) => state?.routerHistory?.[historyName];

export const historySelector = createSelector(gethistories, state => state);
